import React, { Component } from 'react';

import { Polyline } from 'google-maps-react';


class PhaseCrossLayer extends Component {



    componentDidMount() {
        this.loadPhaseCrossLayer();
    }

    shouldComponentUpdate(nextProps) {
        if (this.props.ohlsList.length !== nextProps.ohlsList.length
            || this.props.zoomLevel !== nextProps.zoomLevel
            || this.props.showPhaseCross !== nextProps.showPhaseCross) {
            return true;
        }
        else {
            return false;
        }
    }

    componentDisUpdate() {
        this.loadPhaseCrossLayer();
    }


    loadPhaseCrossLayer = () => {

        let resultList = [];

        const phaseCrossColor = '#ffff00';

        if (this.props.showPhaseCross && this.props.zoomLevel >= 1) {
            this.props.ohlsList.forEach((ohl, ohlIndex) => {
                if (ohl.phaseCross) {
                    ohl.phaseCross.forEach((phaseCross, index) => {
                        const cross =
                            <Polyline
                                key={ohl.name + String(ohlIndex) + String(index)}
                                path={phaseCross.position}
                                clicable
                                onClick={this.props.onPhaseCrossClick}
                                strokeOpacity={1}
                                strokeColor={phaseCrossColor}
                                strokeWeight={5}
                                spanName={phaseCross.name}
                                ohls={phaseCross.OHLs}
                                crosses={phaseCross.phases}

                            />
                        resultList.push(cross);
                    })
                }
            })
        }

        this.props.sendChildElementDataToState(this.props.stateElementName, resultList);
    }


    render() {
        return null;
    }

}

export default PhaseCrossLayer;

